import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

function getHeaders() {
  const user = JSON.parse(localStorage.getItem("user"));
  return { Authorization: "Bearer " + user?.Token, Accept: "*/*" };
}
const API = process.env.REACT_APP_API_URL;

export const getInvoiceableJr = createAsyncThunk("invV2/invoiceable", async (klienID = "", { rejectWithValue }) => {
  try {
    const fd = new FormData();
    fd.append("KlienID", klienID);
    const res = await axios.post(API + "getInvoiceableJr", fd, { headers: getHeaders() });
    return res.data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const generateInvoice = createAsyncThunk("invV2/generate", async (payload, { rejectWithValue }) => {
  try {
    const res = await axios.post(API + "generateInvoice", payload, { headers: getHeaders() });
    return res.data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const getInvoiceList = createAsyncThunk("invV2/list", async (search = "", { rejectWithValue }) => {
  try {
    const fd = new FormData();
    fd.append("search", search);
    const res = await axios.post(API + "getInvoiceListV2", fd, { headers: getHeaders() });
    return res.data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const getInvoiceDetail = createAsyncThunk("invV2/detail", async (invNo, { rejectWithValue }) => {
  try {
    const res = await axios.get(API + "getInvoiceDetailV2", { headers: getHeaders(), params: { invNo } });
    return res.data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

// Reason wajib saat Status = "cancelled" (dicatat di invoice).
export const updateInvoiceStatus = createAsyncThunk("invV2/status", async ({ InvNo, Status, Reason = "" }, { rejectWithValue }) => {
  try {
    const fd = new FormData();
    fd.append("InvNo", InvNo);
    fd.append("Status", Status);
    fd.append("Reason", Reason);
    const res = await axios.post(API + "updateInvoiceStatusV2", fd, { headers: getHeaders() });
    return res.data;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

export const incrementInvoicePrint = createAsyncThunk("invV2/incrementPrint", async (InvNo, { rejectWithValue }) => {
  try {
    const fd = new FormData();
    fd.append("InvNo", InvNo);
    const res = await axios.post(API + "incrementInvoicePrintV2", fd, { headers: getHeaders() });
    return res.data?.data?.PrintCount ?? null;
  } catch (e) { return rejectWithValue(e.response?.data); }
});

const initialState = {
  invoiceable: [],
  list: [],
  detail: null,
  isLoading: false,
  isDetailLoading: false,
  isGenerating: false,
  generatedInvNo: null,
  error: null,
};

const invoiceV2Slice = createSlice({
  name: "invV2",
  initialState,
  reducers: {
    resetGenerated(state) { state.generatedInvNo = null; state.error = null; },
    clearDetail(state) { state.detail = null; },
  },
  extraReducers: (b) => {
    b.addCase(getInvoiceableJr.pending,   (s) => { s.isLoading = true; });
    b.addCase(getInvoiceableJr.fulfilled, (s, a) => { s.isLoading = false; s.invoiceable = a.payload?.data ?? []; });
    b.addCase(getInvoiceableJr.rejected,  (s) => { s.isLoading = false; });

    b.addCase(generateInvoice.pending,   (s) => { s.isGenerating = true; s.generatedInvNo = null; });
    b.addCase(generateInvoice.fulfilled, (s, a) => { s.isGenerating = false; s.detail = a.payload?.data; s.generatedInvNo = a.payload?.data?.InvNo; });
    b.addCase(generateInvoice.rejected,  (s, a) => { s.isGenerating = false; s.error = a.payload?.message; });

    b.addCase(getInvoiceList.pending,   (s) => { s.isLoading = true; });
    b.addCase(getInvoiceList.fulfilled, (s, a) => { s.isLoading = false; s.list = a.payload?.data ?? []; });
    b.addCase(getInvoiceList.rejected,  (s) => { s.isLoading = false; });

    b.addCase(getInvoiceDetail.pending,   (s) => { s.isDetailLoading = true; });
    b.addCase(getInvoiceDetail.fulfilled, (s, a) => { s.isDetailLoading = false; s.detail = a.payload?.data; });
    b.addCase(getInvoiceDetail.rejected,  (s) => { s.isDetailLoading = false; });
  },
});

export const { resetGenerated, clearDetail } = invoiceV2Slice.actions;
export const invoiceV2Selector = (state) => state.invoiceV2;
export default invoiceV2Slice.reducer;
